module.exports = __webpack_public_path__ + "img/flag-border-green.a33507e3.svg";